// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_48-0";